// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2K8uv","list":"PatternAutocomplete_list__3AtJi"};